import { cn } from "@/lib/utils";

interface AvatarProps {
  name: string;
  size?: number;
  bordered?: boolean;
  className?: string;
}

export function Avatar({ name, size = 48, bordered, className }: AvatarProps) {
  const initials = name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  return (
    <div
      className={cn(
        "grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#e2e8f0] to-[#cbd5e1] font-bold text-[#2563eb]",
        bordered && "border-2 border-white shadow-[0_0_0_1px_#e2e8f0]",
        className,
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(11, Math.round(size * 0.34)),
      }}
    >
      {initials || "·"}
    </div>
  );
}
